import apiClient from './client';

export interface ItemSuggestion {
  name: string;
  count: number;
}

export interface PricePoint {
  store_name: string;
  unit_price: number;
  receipt_date: string;
  receipt_id: string;
}

export interface PriceComparison {
  item_name: string;
  prices: PricePoint[];
}

export interface CheapestItem {
  item_name: string;
  cheapest_store: string;
  unit_price: number;
  last_seen: string;
}

export const itemsApi = {
  search: async (q: string): Promise<ItemSuggestion[]> => {
    const response = await apiClient.get('/items/search', { params: { q } });
    return response.data;
  },
  getPriceComparison: async (itemName: string): Promise<PriceComparison> => {
    const response = await apiClient.get('/items/price-comparison', { params: { item_name: itemName } });
    return response.data;
  },
  getCheapestItems: async (limit = 20): Promise<CheapestItem[]> => {
    const response = await apiClient.get('/items/cheapest', { params: { limit } });
    return response.data.items;
  },
};
